import Index from './Trucks'
import IndexHeading from './IndexHeading'
import CreateHeading from './CreateHeading'
import EditHeading from './EditHeading'
import Form from './Form'
import DriverModal from './DriverModal'

export default {
  Index,
  IndexHeading,
  CreateHeading,
  EditHeading,
  Form,
  DriverModal
}



// WEBPACK FOOTER //
// ./src/components/trucks/index.js